<template>
<div class="chapter">
<div class="inner_page">
<div class="Contents_Page">
<h2 class="fmtitle"><i>CONTENTS</i></h2>
<p class="br"> </p>
<p class="toc1"><a href="#/06_Introduction#s1" id="r1">Introduction</a></p>
<p class="toc1"><a href="#/07_Chapter1#s2" id="r2"><i>The Mysterious Affair at Styles</i>, Agatha Christie (1915)</a></p>
<p class="toc"><span href="#/08_Chapter2#s3" id="r3" title="Link target outside of Sample"><i>The Yellow Wallpaper</i>, Charlotte Perkins Gilman (1892)</span></p>
<p class="toc"><span href="#/09_Chapter3#s4" id="r4" title="Link target outside of Sample"><i>Why I Wrote “The Yellow Wallpaper</i>,” Charlotte Perkins Gilman (1913)</span></p>
<p class="toc"><span href="#/10_Chapter4#s5" id="r5" title="Link target outside of Sample"><i>Letter to Fanny Knight</i>, Jane Austen (1814)</span></p>
<p class="toc"><span href="#/11_Chapter5#s6" id="r6" title="Link target outside of Sample"><i>Cousin Phillis</i>, Elizabeth Gaskell (1864)</span></p>
<p class="toc"><span href="#/12_Chapter6#s7" id="r7" title="Link target outside of Sample"><i>Luella Miller</i>, Mary E. Wilkins Freeman (1903)</span></p>
<p class="toc"><span href="#/13_Chapter7#s8" id="r8" title="Link target outside of Sample"><i>Life</i>, Charlotte Brontë (1846)</span></p>
<p class="toc"><span href="#/14_Chapter8#s9" id="r9" title="Link target outside of Sample"><i>Stars</i>, Emily Brontë (1846)</span></p>
<p class="toc"><span href="#/15_Chapter9#s10" id="r10" title="Link target outside of Sample"><i>Dreams</i>, Anne Brontë (1846)</span></p>
<p class="toc"><span href="#/16_Chapter10#s11" id="r11" title="Link target outside of Sample"><i>Silly Novels by Lady Novelists</i>, George Eliot (1856)</span></p>
<p class="toc"><span href="#/17_Chapter11#s12" id="r12" title="Link target outside of Sample"><i>From</i> The Romance of the Forest, Ann Radcliffe (1791)</span></p>
<p class="toc"><span href="#/18_Chapter12#s13" id="r13" title="Link target outside of Sample"><i>Frankenstein</i>, Mary Shelley (1818)</span></p>
<p class="toc"><span href="#/19_Chapter13#s14" id="r14" title="Link target outside of Sample"><i>Contemplations</i>, Anne Bradstreet (1650)</span></p>
<p class="toc"><span href="#/20_Chapter14#s15" id="r15" title="Link target outside of Sample"><i>A Call</i>, Grace MacGowan Cooke (1906)</span></p>
<p class="toc"><span href="#/21_Chapter15#s16" id="r16" title="Link target outside of Sample"><i>Goblin Market</i>, Christina Rossetti (1862)</span></p>
<p class="toc"><span href="#/22_Chapter16#s17" id="r17" title="Link target outside of Sample"><i>On the Gulls’ Road</i>, Willa Cather (1908)</span></p>
<p class="toc"><span href="#/23_Chapter17#s18" id="r18" title="Link target outside of Sample"><i>Poems</i>, Emily Dickinson (1890)</span></p>
<p class="toc"><span href="#/24_Chapter18#s19" id="r19" title="Link target outside of Sample"><i>The Voyage Out</i>, Virginia Woolf (1915)</span></p>
<p class="toc"><span href="#/25_Chapter19#s20" id="r20" title="Link target outside of Sample"><i>Renascence</i>, Edna St. Vincent Millay (1912)</span></p>
<p class="toc"><span href="#/26_Chapter20#s21" id="r21" title="Link target outside of Sample"><i>Xingu</i>, Edith Wharton (1916)</span></p>
<p class="toc"><span href="#/27_Chapter21#s22" id="r22" title="Link target outside of Sample"><i>Patterns</i>, Amy Lowell (1917)</span></p>
<p class="toc"><span href="#/28_Chapter22#s23" id="r23" title="Link target outside of Sample"><i>The Garden Party</i>, Katherine Mansfield (1922)</span></p>
<p class="toc"><span href="#/29_Chapter23#s24" id="r24" title="Link target outside of Sample"><i>Tender Buttons</i>, Gertrude Stein (1914)</span></p>
<p class="toc"><span href="#/30_Chapter24#s25" id="r25" title="Link target outside of Sample"><i>The Shadowy Third</i>, Ellen Glasgow (1916)</span></p>
<p class="toc"><span href="#/31_Chapter25#s26" id="r26" title="Link target outside of Sample"><i>Afterward</i>, Edith Wharton (1910)</span></p>
<p class="toc"><span href="#/32_Chapter26#s27" id="r27" title="Link target outside of Sample"><i>Poems</i>, Sara Teasdale (1920)</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?37131080